import { TopupOrderPagedResponse } from "../../../../../grpc-api/shared/domains/vlp-billing/vlp-billing-history-topup-request-response";
import { TopupOrder } from "./topup-order.model";
export class TopupAttention {
    PopupOnNew = false;
    PopupOnLogin = false;
    Enabled = false;
    SoundEnabled = false;
    IconEnabled = false;
    RingCount = 3;
    ReminderMinutes = 5;
    EscalationMinutes = 15;
    PendingCount = 0;
    OverdueCount = 0;
    Scope = "";
    ReminderKey = "";
    Orders: TopupOrder[] = [];
    constructor(dto?: TopupOrderPagedResponse) {
        if (!dto) return;
        this.PopupOnNew = dto.popupOnNew; this.PopupOnLogin = dto.popupOnLogin;
        this.Enabled = dto.attentionEnabled; this.SoundEnabled = dto.soundEnabled;
        this.IconEnabled = dto.iconEnabled; this.RingCount = dto.ringCount;
        this.ReminderMinutes = dto.reminderMinutes; this.EscalationMinutes = dto.escalationMinutes;
        this.PendingCount = dto.totalRecords; this.OverdueCount = dto.overdueCount;
        this.Scope = dto.attentionScope; this.ReminderKey = dto.reminderKey;
        this.Orders = dto.items.map(item => TopupOrder.fromDto(item));
    }
}
